var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 193,
    viewBox: "0 0 193 193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    "data-name": "Group 2129",
    transform: "translate(-543 -2926)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712",
    "data-name": "Rectangle 1712",
    width: 193,
    height: 193,
    transform: "translate(543 2926)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Less_than_100MB",
    "data-name": "Less than 100MB",
    transform: "translate(583 3032)",
    fill: "#a8a8a8",
    fontSize: 14,
    fontFamily: "Inter-Regular, Inter",
    letterSpacing: "0.011em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "Less than 100MB")), /*#__PURE__*/React.createElement("text", {
    id: "Report_PDF",
    "data-name": "Report PDF",
    transform: "translate(573 3019)",
    fill: "#707070",
    fontSize: 25,
    fontFamily: "Inter-Medium, Inter",
    fontWeight: 500,
    letterSpacing: "0.011em",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Report PDF")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPlaceholder);
export default __webpack_public_path__ + "static/media/pdfPlaceholder.b08cb2faa8ac59d03d6b4be0850fa549.svg";
export { ForwardRef as ReactComponent };